// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__32PPU","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1JONK"};